<template>
  <div class="content page-content" v-loading="loading">
    <ListButton
      :buttonObj="buttonObj"
      :buttonList="buttonList"
      :selected="selected"
      @create="handleCreate"
      v-on:clickType="OnCheckList"
      :tagsData="projectOrder.routerParams.scheduleName"
      @deleteTag="handleDeleteTag"
    ></ListButton>
    <el-row>
      <Table
        ref="table"
        :props="table.props"
        :header="table.header.filter(item => item.isShow === true)"
        :data="table.data"
        :selected="table.selected"
        :selection-type="table.selectionType"
        @row-selection-add="handleRowSelectionAdd"
        @row-selection-remove="handleRowSelectionRemove"
        @all-row-selection-change="handleAllRowSelectionChange"
      />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </el-row>
    <!--详情-->
    <el-drawer
      :visible.sync="drawer"
      size="60%"
      :modal="false"
      :destroy-on-close="true"
      class="detail-drawer"
      :with-header="false"
      @reload-content="handleReloadContent"
    >
      <Read v-if="drawer" :mediaModel="mediaModel" :tabActiveName="drawerTabsActiveName" @closeDrawer="handleCloseDrawer"></Read>
    </el-drawer>
    <template>
    </template>
  </div>
</template>
<script>
import { Table } from '@ccprivate/admin-toolkit'
import ListButton from '@/components/ListButton'
import { debounce } from 'lodash'
import Read from './MaterialCreativeRead'
import { scheduleStatusEnum, checkStatusEnum } from './MaterialCreative'
export default {
  components: {
    Table,
    ListButton,
    Read
  },
  inject: ['projectOrder'],
  data() {
    return {
      drawer: false,
      loading: false,
      mediaId: '',
      scheduleId: '',
      mediaModel: {},
      drawerTabsActiveName: 'detail',
      mediaClassTypeEnum: {},
      buttonObj: {
        title: '创意',
        permissionData: 'media:add'
      },
      buttonList: [
        {
          icon: 'el-icon-caret-right',
          title: '启用',
          key: 'start',
          permission: 'scheduleMedia:operate',
          disabled: true
        },
        {
          icon: 'el-icon-cc-pause',
          title: '暂停',
          key: 'pause',
          permission: 'scheduleMedia:operate',
          disabled: true
        }
      ],
      showClose: false,
      checkTableHeader: [],
      tableHeader: [],
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 1,
      // 查询的页码
      start: 1,
      filter: {},
      table: {
        props: {
          border: 'border',
          'tooltip-effect': 'dark'
        },
        // table的width全部需要改成min-width，并且保证自定义之后表格不乱
        header: [
          {
            label: '',
            align: 'center',
            prop: 'operateStatus',
            isShow: this.getTableOpen(),
            width: 70,
            fixed: 'left',
            render: (h, { row }) => {
              return h('el-switch', {
                props: {
                  disabled: row.checkStatus !== 4 || row.scheduleSource !== 0,
                  value: row.operateStatus === 1,
                  width: 28
                },
                on: {
                  input: (value) => {
                    const obj = {
                      scheduleMediaIds: [row.scheduleMediaId],
                      operateFlag: value === true ? 1 : 2
                    }
                    if (!value) {
                      this.$confirm(
                        '暂停素材将导致' +
                          row.orderName +
                          '无素材可投放，影响计划量完成，确定暂停？',
                        '提示',
                        {
                          confirmButtonText: '暂停',
                          cancelButtonText: '取消',
                          center: true,
                          showClose: false
                        }
                      )
                        .then(() => {
                          this.$service.operateMaterial(obj).then((data) => {
                            if (data.code === 0) {
                              row.operateStatus = 2
                              this.table.selected = []
                              this.selected = []
                              this.selectedRow = []
                            } else if (data.code !== 0) {
                              this.$message.error(data.errorMsg)
                            }
                          })
                        })
                        .catch(() => {})
                    } else {
                      this.$service.operateMaterial(obj).then((data) => {
                        if (data.code === 0) {
                          row.operateStatus = 1
                          this.table.selected = []
                          this.selected = []
                          this.selectedRow = []
                        } else if (data.code !== 0) {
                          this.$message.error(data.errorMsg)
                        }
                      })
                    }
                  }
                }
              })
            }
          },
          {
            label: '素材创意',
            align: 'left',
            prop: 'mediaName',
            fixed: 'left',
            'min-width': 380,
            isShow: true,
            'show-overflow-tooltip': false,
            render: (h, { row }) => {
              return <div style="display:flex">
                <div>
                  <MediaView
                    width="80px"
                    height="50px"
                    mediaClassId={row.mediaClassId}
                    src={row.mediaIcon}
                    previewSrc={row.mp4Url}
                  ></MediaView>
                </div>
                <div>
                  <el-tooltip content={row.mediaName} placement="top">
                    <div class="cell-content-grid">{row.mediaName}</div>
                  </el-tooltip>
                  <div style="padding: 6px 0 0 12px;color:#999">ID: {row.mediaId}</div>
                </div>
              </div>
            }
          },
          {
            label: '广告主',
            align: 'left',
            prop: 'partnerName',
            'min-width': 200,
            isShow: this.projectOrder.accountType === '1',
            'show-overflow-tooltip': true
          },
          {
            label: '状态',
            align: 'left',
            prop: 'checkStatus',
            'min-width': 100,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return this.$consts.materialStatisText[row.checkStatus]
            }
          },
          {
            label: '投放时间',
            align: 'left',
            prop: 'timeList',
            'min-width': 220,
            isShow: false,
            render: (h, { row }) => {
              let time = []
              for (let i = 0; i < row.timeList.length; i++) {
                time.push(
                  this.$moment(row.timeList[i].beginTime).format('YYYY-MM-DD') +
                    ' ~ ' +
                    this.$moment(row.timeList[i].endTime).format('YYYY-MM-DD')
                )
              }
              return time.join(',')
            }
          },
          {
            label: '类型',
            prop: 'mediaClassId',
            isShow: true,
            'min-width': 150,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return this.mediaClassTypeEnum[row.mediaClassId]
            }
          },
          {
            label: '时长(秒)',
            prop: 'duration',
            isShow: true,
            'min-width': 150,
            'show-overflow-tooltip': true
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'adSpaceName',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '上传时间',
            align: 'left',
            prop: 'createTime',
            'min-width': 200,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '所属计划',
            align: 'left',
            prop: 'scheduleName',
            'min-width': 180,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '计划单号',
            prop: 'scheduleNo',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '所属订单',
            align: 'left',
            prop: 'orderName',
            'min-width': 180,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '订单编号',
            prop: 'orderNo',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '操作栏',
            align: 'left',
            isShow: true,
            fixed: 'right',
            'min-width': 160,
            render: (h, { row }) => {
              const checkStatus = row.checkStatus
              const scheduleStatus = row.scheduleStatus
              const scheduleDisabled =
                scheduleStatus !== scheduleStatusEnum.SAVED.key &&
                scheduleStatus !== scheduleStatusEnum.AUDITING.key &&
                scheduleStatus !== scheduleStatusEnum.USING.key &&
                scheduleStatus !== scheduleStatusEnum.PAUSE.key
              const mediaDisabled =
                checkStatus === checkStatusEnum.DECLINED.key ||
                checkStatus === checkStatusEnum.TESTFAIL.key
              const disabled = scheduleDisabled || mediaDisabled
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text',
                      disabled: disabled
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleEdit(row)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'scheduleMedia:edit'
                      }
                    ]
                  },
                  '编辑'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleRead(row, 'detail')
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'scheduleMedia:detail'
                      }
                    ]
                  },
                  '详情'
                ),
                h(
                  'el-dropdown',
                  {
                    style: {
                      'margin-left': '10px'
                    },
                    on: {
                      command: (event) => {
                        this.handleCommand(row, event)
                      }
                    }
                  },
                  [
                    h('span', {
                      class: 'el-icon-more',
                      style: {
                        color: '#1890FF',
                        lineHeight: '24px',
                        cursor: 'pointer',
                        transform: 'rotate(90deg)'
                      }
                      // on: {
                      //   click: event => {
                      //     if (allDisabled) {
                      //       // event.stopPropagation()
                      //       event.stopImmediatePropagation()
                      //     }
                      //   }
                      // }
                    }),
                    h(
                      'el-dropdown-menu',
                      {
                        slot: 'dropdown',
                        style: {
                          'width': '120px'
                        }
                      },
                      [
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: '日志'
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'media:detail'
                              }
                            ]
                          },
                          '日志'
                        ),
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: '下载'
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'media:download'
                              }
                            ]
                          },
                          '下载'
                        ),
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: '删除'
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'scheduleMedia:operate'
                              }
                            ]
                          },
                          '删除'
                        )
                      ]
                    )
                  ]
                )
              ])
            }
          }
        ],
        data: [],
        selected: [],
        selectionType: 'multiple'
      },
      selected: [],
      selectedRow: []
    }
  },
  computed: {
  },
  watch: {
    'projectOrder.selectForm': {
      handler(newVal, oldVal) {
        this.currentPage = 1
        this.pageSize = 10
        this.table.selected = []
        this.selected = []
        this.selectedRow = []
        this.fetchData()
      },
      deep: true
    },
    'projectOrder.searchParam'(newValue, oldValue) {
      this.currentPage = 1
      this.pageSize = 10
      this.selected = []
      this.table.selected = []
      this.selectedRow = []
    },
    'projectOrder.timeList': {
      handler() {
        this.fetchData()
      },
      deep: true
    },
    selected: {
      handler(newValue, oldVal) {
        // 程序化单不能启用暂停
        const hasProgrammatic = newValue.some(id => {
          const currentRow = this.table.data.find(item => item.scheduleMediaId === id)
          return currentRow ? (currentRow.scheduleSource !== 0) : false
        })
        if (newValue.length > 0 && !hasProgrammatic) {
          this.buttonList.forEach((item) => {
            item.disabled = false
          })
        } else {
          this.buttonList.forEach((item) => {
            item.disabled = true
          })
        }
      },
      deep: true
    }
  },
  methods: {
    getTableOpen() {
      if (this.$appState.$get('permissions')['scheduleMedia:operate']) {
        return true
      } else {
        return false
      }
    },
    fetchData() {
      this.loading = true
      this.filter.pageNo = this.currentPage
      this.filter.pageSize = this.pageSize
      this.filter.order = 'desc'
      this.filter.sort = 'mediaId'
      this.filter.checkStatus =
        this.projectOrder.selectForm.checkStatus !== undefined
          ? this.projectOrder.selectForm.checkStatus
          : undefined
      this.filter.spaceId = this.projectOrder.selectForm.spaceId
        ? this.projectOrder.selectForm.spaceId
        : undefined
      this.filter.scheduleId = this.projectOrder.routerParams.scheduleId
        ? this.projectOrder.routerParams.scheduleId
        : undefined
      this.filter.scheduleStatus = this.projectOrder.selectForm.scheduleStatus
        ? this.projectOrder.selectForm.scheduleStatus
        : undefined
      this.filter.partnerName = this.projectOrder.selectForm.mediaPartnerName
        ? this.projectOrder.selectForm.mediaPartnerName
        : undefined
      this.filter.scheduleNo = this.projectOrder.selectForm.scheduleNo
      this.filter.orderNo = this.projectOrder.selectForm.orderNo
      // this.filter.partnerId = this.projectOrder.selectForm.mediaPartnerId ? this.projectOrder.selectForm.mediaPartnerId : undefined
      this.filter.scheduleStatus =
        this.projectOrder.selectForm.scheduleStatus !== ''
          ? this.projectOrder.selectForm.scheduleStatus
          : undefined
      this.filter.mediaClassId = this.projectOrder.selectForm.mediaClassId
        ? this.projectOrder.selectForm.mediaClassId
        : undefined
      if (this.projectOrder.timeList) {
        this.filter.beginTime = this.$moment(this.projectOrder.timeList[0]).format(
          'YYYY-MM-DD 00:00:00'
        )
        this.filter.endTime = this.$moment(this.projectOrder.timeList[1]).format(
          'YYYY-MM-DD 23:59:59'
        )
      } else {
        this.filter.beginTime = undefined
        this.filter.endTime = undefined
      }
      // 检索名称或id
      if (this.projectOrder.selectNameType !== 3) {
        this.filter.searchParamType = this.projectOrder.selectNameType
        this.filter.searchParam = this.projectOrder.searchParam // 告诉接口查询是订单下的素材、计划下的素材、就素材本身
      }
      this.$service
        .getMaterialList(this.filter)
        .then((data) => {
          this.totalCount = data.total
          this.table.data = []
          this.$nextTick(() => {
            this.table.data = data.rows
            this.updateTableSelected()
          })
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
        })
    },
    handleCreate() {
      this.$emit('create', 0)
    },
    handleEdit(row) {
      this.$emit('edit', row)
    },
    async handleRead(row, tabs) {
      this.mediaId = row.mediaId
      this.scheduleId = row.scheduleId
      await this.handleOpenDrawer()
      this.drawer = true
      this.drawerTabsActiveName = tabs
    },
    handleDeleteTag() {
      this.projectOrder.routerParams.scheduleId = ''
      this.projectOrder.routerParams.scheduleName = ''
      this.$router.push({
        name: 'adServingManage'
      })
    },
    OnCheckList(value) {
      let obj = {
        scheduleMediaIds: this.selected,
        operateFlag: value === 'start' ? 1 : 2
      }
      if (value === 'start' || value === 'pause') {
        const ids = this.selectedRow.reduce((result, item) => {
          if (value === 'start') {
            if (item.checkStatus === 4 && item.operateStatus === 2) {
              result.push(item.mediaId)
            }
          } else {
            if (item.checkStatus === 4 && item.operateStatus === 1) {
              result.push(item.mediaId)
            }
          }
          return result
        }, [])
        const isOnlyEffectiveMediaNames = this.selectedRow
          .filter((item) => {
            return (
              item.checkStatus === 4 &&
              item.operateStatus === 1 &&
              item.isOnlyEffective === 1
            )
          }).reduce((result, item) => {
            result.push(item.mediaName)
            return result
          }, [])
        obj.ids = ids
        if (ids.length > 0) {
          if (isOnlyEffectiveMediaNames.length > 0) {
            this.$confirm(
              '暂停素材将导致【' +
                isOnlyEffectiveMediaNames.join(',') +
                '】无素材可投放，影响计划量完成，确定暂停？',
              '提示',
              {
                confirmButtonText: '暂停',
                cancelButtonText: '取消',
                center: true,
                showClose: false
              }
            )
              .then(() => {
                this.$service.updateMedia(obj).then((data) => {
                  const message = value === 'start' ? '启用' : '暂停'
                  this.$message.success('已为您' + message + ids.length + '条素材')
                  this.fetchData()
                  this.table.selected = []
                  this.selected = []
                  this.selectedRow = []
                })
              })
              .catch(() => {})
          } else {
            this.$service.updateMedia(obj).then((data) => {
              const message = value === 'start' ? '启用' : '暂停'
              this.$message.success('已为您' + message + ids.length + '条素材')
              this.fetchData()
              this.table.selected = []
              this.selected = []
              this.selectedRow = []
            })
          }
        } else {
          this.$message.error('只能启用/暂停已测试的素材')
        }
      }
    },
    handleChangeTableHeader(e) {
      e.isCheck = !e.isCheck
      let index = this.table.header.findIndex((item) => item.label === e.label)
      this.table.header[index].isShow = e.isCheck
      this.$store.commit('saveMediaTable', this.table.header)
    },
    handleOpenDrawer() {
      this.loading = true
      return this.$service
        .getMaterialById({ mediaId: this.mediaId, scheduleId: this.scheduleId })
        .then((data) => {
          this.loading = false
          if (data) {
            this.mediaModel = data
            this.mediaModel.activeEventTab = 'keyEventList'
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleCloseDrawer() {
      this.drawer = false
    },
    // 表格操作
    handleRefresh() {
      this.currentPage = 1
      this.filter = {}
      this.fetchData()
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleRowSelectionAdd(targetItem) {
      this.selected.push(targetItem.scheduleMediaId)
      this.selectedRow.push(targetItem)
      this.updateTableSelected()
    },
    handleRowSelectionRemove(targetItem) {
      this.selected = this.selected.filter((item) => {
        return item !== targetItem.scheduleMediaId
      })
      this.selectedRow = this.selectedRow.filter((item) => {
        return item.mediaId !== targetItem.mediaId
      })
      this.updateTableSelected()
    },
    handleAllRowSelectionChange(value) {
      if (value) {
        this.table.data.forEach(this.handleRowSelectionAdd)
      } else {
        this.selected = []
        this.selectedRow = []
        this.table.selected = []
      }
    },
    handleAllRowSelectionRemove() {
      this.selected = []
      this.table.selected = []
      this.selectedRow = []
    },
    updateTableSelected() {
      const table = this.table
      const newSelectedIndex = this.selected
      table.selected = table.data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.scheduleMediaId) > -1) {
          result.push(index)
        }
        return result
      }, [])
    },
    handleFilterChange(type, filter) {
      if (filter) {
        this.filter = filter
      }
      if (type === 'query') {
        this.pagination.currentPage = 1
      }
      this.fetchData()
    },
    handleCommand(e, command) {
      if (command === '删除') {
        const obj = {
          scheduleMediaIds: [e.scheduleMediaId],
          operateFlag: 3
        }
        const confirmText =
          e.isOnlyEffective === 0
            ? '确定从' + e.orderName + '中删除' + e.mediaName + '?'
            : '删除该素材将导致' +
              e.orderName +
              '无素材可投放，影响计划量完成，确定删除？'
        this.$confirm(confirmText, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          center: true,
          showClose: false
        })
          .then(() => {
            this.$service.updateMedia(obj).then((data) => {
              this.$message.success('已为您删除1条素材')
              this.fetchData()
              this.selected = []
              this.table.selected = []
            })
          })
          .catch(() => {})
      }
      if (command === '日志') {
        this.handleRead(e, 'log')
      }
      if (command === '下载') {
        this.$service.downLoadImgFile({ mediaId: e.mediaId }).then((result) => {
          const a = document.createElement('a')
          a.href = result.url
          a.target = '_self'
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
      }
    },
    handleReloadContent() {
      this.fetchData()
      this.handleOpenDrawer()
    },
    getMediaClass() {
      this.$service.getMediaClass().then(data => {
        this.mediaClassTypeEnum = data.reduce((prev, cur) => {
          prev[cur.mediaClassId] = cur.mediaClassName
          return prev
        }, {})
      })
    }
  },
  mounted() {
    this.table.header =
      this.$store.state.mediaTable.length > 0
        ? this.$store.state.mediaTable
        : this.table.header
  },
  created() {
    this.table.data = []
    // 点击计划单跳转过来
    if (this.$route.params.paramsObj) {
      const scheduleObj = this.$route.params.paramsObj
      this.projectOrder.routerParams.scheduleName = scheduleObj.scheduleName
      // this.tagsData = scheduleObj.scheduleName
      this.projectOrder.routerParams.scheduleId = scheduleObj.scheduleId
    }
    // 点击计划单详情跳转过来
    if (this.$route.params.mediaId && this.$route.params.scheduleId) {
      const obj = this.$route.params
      this.$nextTick(() => {
        this.handleRead(obj, 'detail')
      })
    }
    this.getMediaClass()
    this.fetchData()
    this.fetchDataDebounced = debounce(this.fetchData, 500)
  }
}
</script>
<style lang="stylus" scoped>
.page-content
  padding 0 16px
>>> .table-input input
  border none
  line-height 22px
  height 22px
.table-header-button
  border none !important
.el-tabs--border-card
  border none
>>> .el-tabs--border-card>.el-tabs__header
  border none
>>>.el-table-button-text
  color #1890FF
>>>.el-table-button-text.is-disabled
  color #C0C4CC
>>>.table-status
  display flex
  flex-direction row
  align-items center
>>>.cell-content-grid
  width 100%
  padding-left 12px
  overflow hidden
  display -webkit-box
  display -moz-box
  text-overflow ellipsis
  -webkit-line-clamp 1
  -webkit-box-orient vertical
  white-space normal
</style>
